import { TextDataForInput } from "../../modules/chat/types";

export const EMPTY_MESSAGE: TextDataForInput = {
  text: "",
  entities: [],
  replyMessageId: "",
};
